export function smoothSlider() {
    const $window = $(window);
    const $slider = $(".smooth-slider");
    $slider.each(function () {
        $(this).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 10000,
            cssEase: 'linear',
            infinite: true,
            draggable: true,
            swipe: true,
            touchMove: true,
            variableWidth: true,
            arrows: false,
            dots: false
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/smoothSlider.js